import {
    POS_VERIFICATION_CHANGE_START,
    POS_VERIFICATION_CHANGE_SUCCESS,
    POS_VERIFICATION_CHANGE_ERROR
} from '../../constants/index';
import showToaster from '../../helpers/showToaster';
import gql from 'graphql-tag';
import getCompletedBookings from '../../routes/site-admin/completedBooking/getCompletedBookings.graphql'
export default function posVerifyConfirmation(bookingId, status) {
    return async (dispatch, getState, { client }) => {
        dispatch({
            type: POS_VERIFICATION_CHANGE_START,
            payload: {
                posVerificationChangeLoading: true
            }
        });


        try {

            let mutation = gql`
            mutation updatePOSStatus($id: Int, $isPayoutVerified: Boolean) {
                updatePOSStatus(id: $id, isPayoutVerified: $isPayoutVerified) {
                  status
                  errorMessage
                }
              }
            `;


            const { data } = await client.mutate({
                mutation,
                variables: {
                    id: bookingId,
                    isPayoutVerified: true
                },
                // refetchQueries: [{ query: getCompletedBookings, variables: { currentPage, searchList } }]
            });

            if (data && data.updatePOSStatus && data.updatePOSStatus.status == 200) {
                dispatch({
                    type: POS_VERIFICATION_CHANGE_SUCCESS,
                    payload: {
                        posVerificationChangeLoading: false
                    }
                });
                showToaster({ messageId: 'statusUpdate', toasterType: 'success' });
                return {
                    status: 200
                }
            } else {
                dispatch({
                    type: POS_VERIFICATION_CHANGE_ERROR,
                    payload: {
                        posVerificationChangeLoading: false
                    }
                });
                showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: '' })
            }
        } catch (err) {
            showToaster({ messageId: 'catchError', toasterType: 'error', requestContent: err })
            dispatch({
                type: POS_VERIFICATION_CHANGE_ERROR,
                payload: {
                    posVerificationChangeLoading: false
                }
            });
        }

    }
};